<template>
    <rkm-modal
        :title="title"
        large
        ref="RkmModal"
    >
        <rkm-alert
            v-if="item && item.registroCodigo === enums.registro.BPA_INDIVIDUALIZADO"
            class="mb-3"
        >
            {{ item.pacienteNome }}
        </rkm-alert>

        <rkm-table
            :fields="fields"
            :items="items"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
                color="secondary"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Enums.
import registro from '@/enums/sigtap/registro'

// Mixins.
import { error, formats, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        title() {
            let title = ''

            if (this.item) {
                title = `Inconsistências do procedimento ${this.formatProcedimento(this.item.procedimentoCodigo)}`
            }

            return title
        },
    },
    created() {
        this.repositories.relatorioInconsistencia = this.getConectaSusRepository('bpa.relatorioInconsistencia')
    },
    data: () => ({
        enums: { registro },
        fields: [
            { key: 'codigo', label: 'Código' },
            { key: 'descricao', label: 'Descrição' },
        ],
        item: null,
        items: [],
        repositories: {},
    }),
    filters: {
        ...formats,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {
            this.item = item
            this.load()
            this.$refs.RkmModal.show()
        },
        load() {
            this.setLoading()

            if (this.item.registroCodigo === this.enums.registro.BPA_INDIVIDUALIZADO) {
                const request = {
                    origem: this.item.origem,
                    unidadeId: this.item.unidadeId,
                    competenciaId: this.item.competenciaId,
                    pacienteId: this.item.pacienteId,
                    procedimentoId: this.item.procedimentoId,
                    ocupacaoId: this.item.ocupacaoId,
                }

                this.repositories.relatorioInconsistencia.index(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.items = response.data
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.repositories.relatorioInconsistencia.show(this.item.id)
                    .then(response => {
                        this.items = response.data
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
    },
    mixins: [ error, formats, repository, stringCase ],
}
</script>